module.exports = __webpack_public_path__ + "static/media/Yoonit.ef60d891.svg";